import type { Template } from "@/types";

export const LA_07_H2_V5: Template[] = [
    {
        id: "la-07-h2v5-01",
        name: "LA 01 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 99, y: 101, width: 232, height: 168, rotation: 0, imageRotation: 0 },
            { id: "2", x: 99, y: 277, width: 232, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 339, y: 101, width: 239, height: 343, rotation: 0, imageRotation: 0 },
            { id: "4", x: 845, y: 46, width: 166, height: 222, rotation: 0, imageRotation: 0 },
            { id: "5", x: 845, y: 276, width: 166, height: 221, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1019, y: 46, width: 165, height: 222, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 276, width: 165, height: 221, rotation: 0, imageRotation: 0 }           
        ],
    },

    {
        id: "la-07-h2v5-02",
        name: "LA 02 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 62, y: 64, width: 289, height: 202, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 274, width: 289, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 358, y: 64, width: 256, height: 412, rotation: 0, imageRotation: 0 },
            { id: "4", x: 821, y: 65, width: 280, height: 412, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1109, y: 65, width: 94, height: 132, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1109, y: 205, width: 94, height: 132, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1109, y: 345, width: 94, height: 132, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-03",
        name: "LA 03 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_03.png",
        size: [1352, 541],
        style: {},
        slots: [        
            { id: "1", x: 133, y: 50, width: 310, height: 217, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 275, width: 310, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 451, y: 50, width: 94, height: 143, rotation: 0, imageRotation: 0 },
            { id: "4", x: 451, y: 201, width: 94, height: 142, rotation: 0, imageRotation: 0 },
            { id: "5", x: 451, y: 351, width: 94, height: 142, rotation: 0, imageRotation: 0 },
            { id: "6", x: 800, y: 103, width: 212, height: 336, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1020, y: 103, width: 211, height: 336, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-04",
        name: "LA 04 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_04.png",
        size: [1352, 541],
        style: {},
        slots: [         
            { id: "1", x: 133, y: 50, width: 94, height: 142, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 200, width: 94, height: 142, rotation: 0, imageRotation: 0 },
            { id: "3", x: 133, y: 350, width: 94, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 235, y: 50, width: 310, height: 217, rotation: 0, imageRotation: 0 },
            { id: "5", x: 235, y: 275, width: 310, height: 217, rotation: 0, imageRotation: 0 },
            { id: "6", x: 769, y: 78, width: 242, height: 384, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 78, width: 241, height: 384, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-05",
        name: "LA 05 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 47, y: 166, width: 284, height: 211, rotation: 0, imageRotation: 0 },
            { id: "2", x: 338, y: 166, width: 284, height: 211, rotation: 0, imageRotation: 0 },
            { id: "3", x: 630, y: 166, width: 129, height: 211, rotation: 0, imageRotation: 0 },
            { id: "4", x: 767, y: 166, width: 129, height: 211, rotation: 0, imageRotation: 0 },
            { id: "5", x: 904, y: 166, width: 128, height: 211, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1040, y: 166, width: 128, height: 211, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1176, y: 166, width: 128, height: 211, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-06",
        name: "LA 06 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 389, height: 541, rotation: 0, imageRotation: 0 },
            { id: "2", x: 746, y: 86, width: 265, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 746, y: 271, width: 129, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 883, y: 271, width: 128, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1019, y: 86, width: 264, height: 177, rotation: 0, imageRotation: 0 },          
            { id: "6", x: 1019, y: 271, width: 128, height: 184, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1155, y: 271, width: 128, height: 184, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-07",
        name: "LA 07 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 676, height: 541, rotation: 0, imageRotation: 0 },
            { id: "2", x: 783, y: 40, width: 462, height: 315, rotation: 0, imageRotation: 0 },
            { id: "3", x: 783, y: 363, width: 86, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 877, y: 363, width: 86, height: 137, rotation: 0, imageRotation: 0 },
            { id: "5", x: 971, y: 363, width: 86, height: 137, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1065, y: 363, width: 86, height: 137, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1159, y: 363, width: 86, height: 137, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-08",
        name: "LA 08 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_08.png",
        size: [1352, 541],
        style: {},
        slots: [           
            { id: "1", x: 234, y: 59, width: 132, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 234, y: 275, width: 132, height: 207, rotation: 0, imageRotation: 0 },
            { id: "3", x: 374, y: 59, width: 131, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 374, y: 275, width: 131, height: 207, rotation: 0, imageRotation: 0 },
            { id: "5", x: 513, y: 59, width: 306, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 513, y: 275, width: 306, height: 207, rotation: 0, imageRotation: 0 },
            { id: "7", x: 827, y: 59, width: 291, height: 423, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-09",
        name: "LA 09 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 97, width: 210, height: 345, rotation: 0, imageRotation: 0 },
            { id: "2", x: 218, y: 97, width: 210, height: 345, rotation: 0, imageRotation: 0 },
            { id: "3", x: 436, y: 97, width: 476, height: 345, rotation: 0, imageRotation: 0 },
            { id: "4", x: 919, y: 97, width: 210, height: 345, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1137, y: 97, width: 217, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1137, y: 264, width: 104, height: 178, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1248, y: 264, width: 104, height: 178, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-10",
        name: "LA 10 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 97, width: 476, height: 345, rotation: 0, imageRotation: 0 },
            { id: "2", x: 484, y: 97, width: 210, height: 345, rotation: 0, imageRotation: 0 },
            { id: "3", x: 701, y: 97, width: 210, height: 345, rotation: 0, imageRotation: 0 },
            { id: "4", x: 919, y: 97, width: 210, height: 345, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1137, y: 97, width: 217, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1137, y: 264, width: 104, height: 178, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1248, y: 264, width: 104, height: 178, rotation: 0, imageRotation: 0 }
        ],
    }
];